const FollowUpTaskItem = ({ itemName, className }) => {
    return (
        <div className={`follow-up-task__item ${className ? className : ""}`}>
            <span>{itemName}</span>
        </div>
    );
};

export default FollowUpTaskItem;
